/* eslint-disable indent */
import environment from "environment";
import qs from "qs";
import get from "lodash.get";
import {request as RequestService, type Permission } from "@fas/ui-framework";
import { userService } from "../user";
import { getHashValue } from "../jusCan";

const getAuthorizationHeaders = (): Record<string, string> => ({
  "X-Api-Key": userService.getApiKey() || "",
  "Account-Id": getHashValue(),
});

export const loginUrl = `${environment.endpoints.get.loginUrl}?r=${window.location.href}`;

export const requestService: RequestService = new RequestService({
  timeout: 360 * 10000,
  headers: { credentials: "include" },
  paramsSerializer: (params: any) => qs.stringify(params),
  customAttr: {
    getAuthorizationHeaders,
    redirect: () => {
      window.location.href = loginUrl;
    },
  },
});

type FetchUserInfoResponse = {
  data: {
    user: unknown;
  };
};

export const fetchUserInfo = (): Promise<{api: string | null}> => requestService
  .get(environment.endpoints.get.apiKey, {
    customAttr: { ignoreAuthorization: true },
    withCredentials: true,
  } as any)
  .then((body) => {
    userService.setUser(body.data.user);
    return {
      api: userService.getApiKey(),
    };
  });

export const fetchUserPermissions = () => requestService.get(
  environment.endpoints.get.permissions
);

interface PermissionResult {
  accountId: string;
  permissions: Array<{ permission: string }>;
  roleName: string;
}

export const fetchUserInfoWithJUSPermissions = async () => {
  const response = await fetchUserPermissions();
  const result = get(response, "data.result", []) as PermissionResult[];

  const transformedPermissions = result.reduce(
    (acc: string[], { accountId, permissions }: PermissionResult) =>
      acc.concat(permissions.map(({ permission }) => `${accountId}.${permission}`)),
    []
  );

  const user = userService.getUser();

  if (user && user.permissions && user.permissions.obj) {
    user.permissions.obj.push(...(transformedPermissions as unknown as Permission[]));
  }

  userService.setUser(user);

  return userService.getApiKey();
};
